// src/pages/ErrorScreen.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const ErrorScreen = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1); // Navigate to the previous page
  const goHome = () => navigate("/"); // Navigate to the home page

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
      <p className="text-lg text-gray-700 mb-6">Oops! The page you're looking for doesn't exist.</p>
      <div className="flex space-x-4">
        <button
          onClick={goBack}
          className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
        >
          Go Back
        </button>
        <button
          onClick={goHome}
          className="px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default ErrorScreen;
